'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = styleModifierPropTypes;

var _lodash = require('lodash.keys');

var _lodash2 = _interopRequireDefault(_lodash);

var _normalizeModifiers = require('./utils/normalizeModifiers');

var _normalizeModifiers2 = _interopRequireDefault(_normalizeModifiers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Evaluates the modifiers prop against the modifier config. Throw invalid proptype if a
 * modifier is supplied in prop and not found in modifier config.
 * @param  {Object} modifierConfig a modifier config object
 * @return {Boolean:Error}               Returns true or an error
 */
function styleModifierPropTypes(modifierConfig) {
  return function (props, propName, componentName) {
    var modifierNames = (0, _lodash2.default)(modifierConfig);
    var modifiers = (0, _normalizeModifiers2.default)(props[propName]);

    var firstInvalid = modifiers.find(function (name) {
      return !modifierNames.includes(name);
    });

    if (firstInvalid) {
      return new Error('Invalid modifier ' + firstInvalid + ' used in prop ' + propName + ' and supplied to ' + componentName + '. Validation failed.');
    }

    return undefined;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-components-modifiers/dist/styleModifierPropTypes.js
// module id = 1468
// module chunks = 2